import axios from "axios";
import { backend } from "../config/backend";

const API = axios.create({ baseURL: backend.urlEndPoint });

API.interceptors.request.use((req) => {
	if (localStorage.getItem("profile")) {
		req.headers.authorization = `Bearer ${localStorage.getItem("profile").token}`;
	}
	return req;
});

export const getDeposits = async (token, id) => {
	return await API.post(
		"/admin/deposit/getdeposits",
		{
			token,
			id,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const getDepositsAgent = async (token, id) => {
	return await API.post(
		"/admin/deposit/getdepositsagent",
		{
			token,
			id,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const getAddressByCryptoCurrencyNetworkAgent = async (token, cryptoCurrency, network) => {
	return await API.post(
		"/admin/deposit/getdepositaddressagent",
		{
			token,
			cryptoCurrency,
			network,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};
